import { Box, Typography } from '@mui/material';
import React from 'react';
import SubPropertyTypeSelect from './SubPropertyTypeSelect';

interface SubPropertyTypeSectionProps {
  propertyType: string;
}

const SubPropertyTypeSection: React.FC<SubPropertyTypeSectionProps> = ({
  propertyType,
}) => {
  return (
    <Box
      sx={{
        borderTop: '1px solid',
        borderColor: 'grey.200',
        pt: 3,
        mt: 3,
      }}
    >
      <Typography sx={{ mb: 1 }} variant="h5">
        Sub Property Types
      </Typography>
      <Typography variant="body2">
        {' '}
        Select the sub-property type that best matches your listing. This helps
        ensure the right fields and details are shown for your property.
      </Typography>
      <SubPropertyTypeSelect propertyType={propertyType} />
    </Box>
  );
};

export default SubPropertyTypeSection;
